// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-divider_container__PvmEu"};